import { atom } from "recoil";

const GatewayAtom = atom({
  key: "Gateway",
  default: undefined,
});

export { GatewayAtom };
